import templateStr from 'text!./templates/ctrl-group.html';
import _ from 'lodash';

let inputId = 0;

export default () => {
    return {
        require: ['?^form', '?^ngForm'],
        transclude: true,
        scope: {
            label: '@?',
            readonly: '=?',
            disabled: '=?',
            model: '=',
            currency: '@',
            flavor: '@',
            hideInputLabel: '<?',
            explicitErrorMessage: '@?',
            inline: '=?',
            tooltip: '=?',
            step: '=?'
        },
        template: templateStr,

        controller: ['$scope', '$timeout', ($scope, $timeout) => {
            if (!$scope.model) {
                throw new Error(`Input with label "${$scope.label}" has an undefined model scope value`);
            }


            $scope.isVisible = () => {
                return !('visible' in _.get($scope.model, 'aspects', {})) || _.get($scope.model, 'aspects.visible');
            };

            $scope.hideAsterisk = () => {
                return $scope.flavor === 'noAsterisk';
            };

            $scope.pristine = true;
            // once a different value is set on the model then we mark the field as not pristine
            $scope.$watch('model.value', (newValue, oldValue) => {
                $scope.pristine = (!$scope.pristine) ? false : newValue === oldValue;
            });
            $scope.$watch($scope.isVisible, (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    const question = $scope.model.question;
                    const answers = $scope.model.modelValue.answers;

                    question.filters.forEach(filter => {
                        if (answers[filter.questionCode] !== filter.answer) {
                            $scope.model.value = null;
                        }
                    });
                }
            });

            $scope.$timeout = $timeout;
        }],

        link: (scope, element, attrs, ctrls) => {
            const parentForm = ctrls[0];
            scope.gwViewmodelRef = attrs.gwViewmodelRef;

            if (!scope.gwViewmodelRef && scope.model && scope.model._ancestorChain) {
                scope.gwViewmodelRef = scope.model.baseVMNode.pathToItem.asString.replace(/\w+/g, (match) => {
                    return match[0].toLowerCase() + match.substring(1);
                });
                attrs.$set('gwViewmodelRef', scope.gwViewmodelRef);
            }

            if (parentForm && !parentForm.invalidInputs) {
                parentForm.invalidInputs = []; // The IDs of invalid inputs, used to $anchorScroll to correct element
            }
            const validityFn = () => {
                // If the model is a coverage term, use the coveragePublicID property
                const publicID = scope.model.coveragePublicID ? scope.model.coveragePublicID : scope.model.publicID;
                if (!scope.model.aspects.valid && parentForm && parentForm.invalidInputs && !parentForm.invalidInputs.includes(publicID)) {
                    parentForm.invalidInputs.push(publicID);
                } else if (scope.model.aspects.valid) {
                    removeInvalidInput(publicID);
                }

                return scope.model.aspects.valid;
            };

            function removeInvalidInput(publicID) {
                if (parentForm && parentForm.invalidInputs.includes(publicID)) {
                    const i = parentForm.invalidInputs.indexOf(publicID);
                    parentForm.invalidInputs.splice(i, 1);
                }
            }

            const setPristineFn = () => {
                // we need to use this postDigest function here because the
                // watch on 'model.value' in the controller gets called after
                // this function is called even though the model was changed first
                scope.$$postDigest(() => {
                    scope.pristine = true;
                    scope.$apply();
                });
            };

            if (parentForm) {
                const removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
                scope.$on('$destroy', () => {
                    removeInvalidInput();
                    return removeListenerFn();
                });
            }

            if (!('readonly' in scope) && attrs.readonly === '') {
                // if readonly attr exists with no value then set it to true
                scope.readonly = true;
            }

            scope.inputId = inputId++;

            scope.showError = () => {
                const formHasBeenSubmitted = !!(parentForm && parentForm.submitted);
                if (formHasBeenSubmitted) {
                    if ((!_.get(scope.model, 'aspects.valid') && !scope.pristine) || (!_.get(scope.model, 'aspects.valid'))) {
                        if (parentForm) {
                            const firstErrorField = parentForm.getFirstErrorInParentForm(scope.model);

                            if (firstErrorField) {
                                const viewmodelRef = firstErrorField.attributes.getNamedItem('gw-viewmodel-ref').value;
                                if (viewmodelRef === scope.gwViewmodelRef && !parentForm.hasScrolledToError) {
                                    parentForm.hasScrolledToError = true;
                                    scope.scrollToError(firstErrorField);
                                }
                            }
                        }
                        return true;
                    }
                }
            };

            scope.scrollToError = (errorField) =>{
                const box = errorField.getBoundingClientRect();
                const doc = errorField.ownerDocument;
                const docElem = doc.documentElement;
                const clientTop = docElem.clientTop || 0;
                const scrollTop = window.pageYOffset || docElem.scrollTop || 0;
                const top = box.top + (scrollTop - clientTop);
                const centerPosition = top - (window.innerHeight / 2);

                $('html, body').animate({
                    scrollTop: centerPosition
                }, 300);
            };

            element.on('focusin', () => {
                scope.focused = true;
                scope.$apply();
            });
            element.on('focusout', () => {
                scope.focused = false;
                // Wrap apply in timeout function so that it can safely run in the next digest cycle
                scope.$timeout(() => scope.$apply());
            });
        }
    };
};
